module.exports = global["$"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.js-exposed
// module id = 172
// module chunks = 0